import styled from "styled-components"

const StyledFooter = styled.footer`
  background-color: ${(props) => props.theme.d_color_gradients.d_dark};
  @media (max-width: 600px) {
    & > div:nth-of-type(4) {
      background-color: ${(props) => props.theme.d_color_gradients.d_dark};
    }
  }
`
const GoToHead = styled.div`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const FooterBottom = styled.ul`
  & a {
    color: black;
  }
  background-color: ${(props) => props.theme.a_color_gradients.a_medium};
`

const ColoredParagraph = styled.p`
  color: ${(props) => props.theme.c_color_gradients.c_medium};
`
const FooterInfo = styled.div`
  background-color: ${(props) => props.theme.d_color_gradients.d_dark};
  & div {
    background-color: ${(props) => props.theme.d_color_gradients.d_dark};
    color: white;
  }
`

export { StyledFooter, GoToHead, FooterBottom, ColoredParagraph, FooterInfo }
